import { ContractInfo } from 'api/types/httpsTypes/contracts';
import {
  MobileExpandableCard,
  MobileExpandCardTrigger,
} from 'modules/shared-components/MobileExpandableCard';
import { ExpandableCardContent } from '../../../../components/cards';
import { HoldersComponent } from '../../../../trade/stats/holders';
import { useQuery } from '@tanstack/react-query';
import {
  ContractService,
  contractServiceKeys,
} from 'api/services/httpServices/ContractService';
import { duration } from 'moment';
import { formatNumberWithSuffix, safeBig } from 'utils/FormatNumber';

type Props = { contract: ContractInfo };

export function HoldersMobileComponent({ contract }: Props) {
  const params = {
    tokenAddress: contract.generalInfo.address,
  };

  const {
    data: mainData,
    error,
    isLoading,
  } = useQuery({
    queryKey: contractServiceKeys.getHolders(params),
    queryFn: () => ContractService.getHolders(params),
    keepPreviousData: true,
    refetchInterval: duration(12, 'seconds').asMilliseconds(),
  });

  return (
    <MobileExpandableCard
      mobileLabel="Holders"
      trigger={
        <MobileExpandCardTrigger>
          <div className="flex xxs:gap-1 items-center">
            Holders (
            {mainData?.numberOfHolders

              ? formatNumberWithSuffix(safeBig(mainData?.numberOfHolders), {
                  precision: 0,
                })

              : '--'}
            )
          </div>
        </MobileExpandCardTrigger>
      }
    >
      <div className="lg:px-2">
        <ExpandableCardContent className="xxs:space-y-2">
          <HoldersComponent
            mainData={mainData}
            error={error}
            isLoading={isLoading}
            contract={contract}
          />
        </ExpandableCardContent>
      </div>
    </MobileExpandableCard>
  );
}
